export function getAuthErrorMessage(error) {
  const code = error?.code || "";
  if (code === "auth/unauthorized-domain") {
    const host = typeof window !== "undefined" ? window.location.hostname : "this site";
    return (
      `Sign-in is blocked for “${host}”. In Firebase Console → Authentication → Settings → ` +
      "Authorized domains, add mindblows.com (and www.mindblows.com if you use it), then try again."
    );
  }
  if (code === "auth/popup-closed-by-user") return null;
  return error?.message || "Sign-in failed.";
}
